export default () => {
    let data = {};
    let other = {};
    const favorites = localStorage.getItem('favorites');
    const filter = localStorage.getItem('filter');
    const category = localStorage.getItem('category');

    data = { ...data, favorites: favorites ? JSON.parse(favorites) || [] : [] };
    data = { ...data, filter: filter ? JSON.parse(filter) || {} : {} };
    other = { ...other, category: category ? JSON.parse(category) || null : null };

    return {
        loading: {},
        form: {},
        error: {},
        data: data,
        ...other
    }
};